import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import MedalImage from "../../../assets/star-medal.png";
import starImage from "../../../assets/star.png";
import useUserType from "../../../hooks/useUserType";
import CustomModal from "../../CustomModal";

const DragAndDropGameFinishModal = forwardRef(
  ({ cardsCount, numberOfMoves, status, onSubmit, onSubmitReset }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const { isStudent } = useUserType();
    const { t } = useTranslation();

    useImperativeHandle(ref, () => ({
      openModal() {
        setIsOpen(true);
      },
      closeModal() {
        setIsOpen(false);
      },
    }));

    const handleConfirm = () => {
      onSubmit();
      setIsOpen(false);
    };

    const handleResetgame = () => {
      onSubmitReset();
      setIsOpen(false);
    };

    return (
      <CustomModal
        isOpen={isOpen}
        withCloseButton={false}
        onClose={() => setIsOpen(false)}
        className="max-w-[45rem] rounded-2xl border-8 border-blue-500 bg-[#F1F1F1] shadow-xl"
        contentClassname="px-2 py-6 md:px-10"
      >
        {status === "correct" ? (
          <>
            <h2 className="mb-2 text-center text-5xl font-bold text-blue-900">
              {t("drag_game_finish.well_done")}
            </h2>
            <h4 className="mb-6 text-center text-xl text-blue-900">
              {t("drag_game_finish.total_points", {
                points: numberOfMoves,
                total: cardsCount,
              })}
            </h4>
          </>
        ) : (
          <div className="flex flex-col items-center">
            <h2 className="mb-3 text-center text-2xl font-semibold text-blue-900">
              {t("drag_game_finish.encouragement")}
            </h2>
            <div className="mb-4 flex items-center justify-center">
              {[...Array(numberOfMoves)].map((_, index) => (
                <img key={index} src={starImage} alt="star" className="mx-1 flex h-24 w-24" />
              ))}
            </div>
          </div>
        )}

        {status === "correct" && (
          <div className="mb-6 flex justify-center gap-3">
            <img className="w-52" src={MedalImage} />
          </div>
        )}

        {status === "wrong" && (
          <p className="text-center text-xl text-blue-900">{t("drag_game_finish.try_again")}</p>
        )}

        <div className="mt-6 flex items-center justify-between gap-14">
          {status === "correct" ? (
            <button
              onClick={isStudent ? handleConfirm : () => setIsOpen(false)}
              className="wavy-btn relative m-auto w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
            >
              {isStudent ? t("submit") : t("close")}
            </button>
          ) : (
            <button
              onClick={handleResetgame}
              className="wavy-btn relative m-auto w-1/2 rounded-3xl border-4 border-[#ffe4af] bg-orange-500 p-4 text-lg font-semibold text-white transition duration-200"
            >
              {t("play_again")}
            </button>
          )}
        </div>
      </CustomModal>
    );
  }
);

export default DragAndDropGameFinishModal;
